module.exports = __webpack_public_path__ + "static/media/icon-email-del.2679775c.svg";